import { detectImageSlots, slotSourceColumns } from "@/lib/mapper/images";
import type { ProductType, Profile } from "@/lib/mapper/types";

/** Read the active customer id from the cookie (client side). */
export function readActiveCustomerId(): string | null {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(/(?:^|; )v2_active_customer=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}

export function blankProfile(
  productType: ProductType,
  sourceHeaders: readonly string[] = [],
): Profile {
  return {
    productType,
    fields: {},
    defaults: {},
    variants: { enabled: false, optionName: "", options: [] },
    // Image 1…N columns (each paired with its "Image N Alt" column when the
    // sheet has one) become the Images module's slots, in position order.
    images: (() => {
      const slots = detectImageSlots(sourceHeaders);
      return {
        sourceColumns: slotSourceColumns(slots),
        transform: "dropbox-direct" as const,
        ...(slots.some((slot) => slot.alt !== undefined) ? { slots } : {}),
      };
    })(),
  };
}

export function confidenceTone(c: number): string {
  if (c >= 0.85) return "bg-emerald-100 dark:bg-emerald-950/50 text-emerald-800 dark:text-emerald-300";
  if (c >= 0.6) return "bg-amber-100 dark:bg-amber-950/50 text-amber-800 dark:text-amber-300";
  return "bg-slate-200 dark:bg-surface-2 text-slate-700 dark:text-slate-300";
}
